import { Link } from "react-router-dom";
import { t } from "../i18n/t";
import { routes } from "../lib/routes";
import { useAttributionText } from "./Attribution";

export function Footer() {
  const attribution = useAttributionText();
  return (
    <footer className="app-footer" aria-label={t("footer.label")}>
      <p className="attribution">{attribution}</p>
      <p className="footer-links">
        <Link to={routes.privacy()}>{t("footer.privacy")}</Link>
        <Link to={routes.dpa()}>{t("footer.dpa")}</Link>
      </p>
    </footer>
  );
}
